import React from 'react';

export const shipmentEditStyles: Record<string, React.CSSProperties> = {

  // ── Edit Icon Button ─────────────────────────────────────────────────────
  editIconBtn: {
    background: '#f9fafb',
    border: '1px solid #e5e7eb',
    cursor: 'pointer',
    padding: '8px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#6b7280',
    transition: 'all 0.15s ease',
    flexShrink: 0,
    // Explicit reset — prevent inheriting any pill/group styles from parent CSS
    outline: 'none',
    boxShadow: 'none',
    lineHeight: 1,
  },

  // ── Inline input — used for origin / destination ─────────────────────────
  // width is intentionally NOT set here; caller sets it inline per context
  inlineInput: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#1a1a1a',
    border: '1.5px solid #F8B71F',
    borderRadius: '7px',
    padding: '5px 8px',
    outline: 'none',
    background: '#fffdf5',
    fontFamily: 'inherit',
    textAlign: 'center' as const,
    boxShadow: '0 0 0 3px rgba(248,183,31,0.10)',
    // no width — set per usage
  },

  inlineInputError: {
    borderColor: '#ef4444',
    boxShadow: '0 0 0 3px rgba(239,68,68,0.10)',
  },

  errorText: {
    fontSize: '9px',
    color: '#ef4444',
    fontWeight: 500,
    marginTop: '2px',
    textAlign: 'center' as const,
    lineHeight: '1.2',
  },

  // ── Tracking number cell ─────────────────────────────────────────────────
  trackingEditRow: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    gap: '3px',
    width: '100%',
  },

  trackingInput: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#1a1a1a',
    border: '1.5px solid #F8B71F',
    borderRadius: '7px',
    padding: '5px 8px',
    outline: 'none',
    background: '#fffdf5',
    fontFamily: 'inherit',
    textAlign: 'center' as const,
    boxShadow: '0 0 0 3px rgba(248,183,31,0.10)',
    width: '140px',
  },

  lockedBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '3px',
    fontSize: '9px',
    fontWeight: 600,
    color: '#9ca3af',
    background: '#f3f4f6',
    borderRadius: '4px',
    padding: '2px 6px',
    letterSpacing: '0.05em',
    textTransform: 'uppercase' as const,
    cursor: 'not-allowed',
  },

  // ── Warning Banner ───────────────────────────────────────────────────────
  warningBanner: {
    background: '#fffbeb',
    border: '1px solid #fde68a',
    borderRadius: '10px',
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    marginBottom: '6px',
    fontSize: '12px',
    color: '#92400e',
    lineHeight: '1.5',
  },

  warningIcon: {
    flexShrink: 0,
    marginTop: '1px',
    color: '#d97706',
  },

  warningText: {
    flex: 1,
  },

  warningActions: {
    display: 'flex',
    gap: '6px',
    marginTop: '8px',
  },

  warningConfirmBtn: {
    background: '#d97706',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '5px 12px',
    fontSize: '11px',
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },

  warningCancelBtn: {
    background: 'transparent',
    color: '#92400e',
    border: '1px solid #fde68a',
    borderRadius: '6px',
    padding: '5px 12px',
    fontSize: '11px',
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },

  // ── Save / Cancel ────────────────────────────────────────────────────────
  saveBtn: {
    background: '#F8B71F',
    color: '#1a1a1a',
    border: 'none',
    borderRadius: '8px',
    padding: '8px 20px',
    fontSize: '12px',
    fontWeight: 700,
    cursor: 'pointer',
    fontFamily: 'inherit',
    whiteSpace: 'nowrap' as const,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '5px',
    width: '100%',
  },

  cancelBtn: {
    background: 'transparent',
    color: '#6b7280',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    padding: '7px 20px',
    fontSize: '12px',
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit',
    whiteSpace: 'nowrap' as const,
    width: '100%',
    textAlign: 'center' as const,
  },
};